define(['app/helpers/visibility'], function (Visibility) {
    function KlarnaController() {
        var publics = {};
        var privates = {};
        publics.allowResume = true;
        publics.klarnaOrder = false;
        privates.oldKlarnaOrder = false;
        publics.changesWaiting = false;
        publics.id = false;
        publics.lostFocus = false;
        publics.waitingForOnload = false;
        privates.timeout = false;
        privates.eventsRegistered = false;
        privates.syncRegistered = false;
        privates.shippingAddressActive = false;

        publics.init = function () {
            publics.updateOrder(true);

            partyking.common.models.shoppingcart.on('update', function () {
                publics.updateOrder(false);
            });
        };

        publics.updateOrder = function (firstLoad) {
            if ((publics.klarnaOrder && publics.klarnaOrder.postingOrder) || publics.waitingForOnload) {
                publics.changesWaiting = true;
                return false;
            }

            publics.klarnaOrder = partyking.common.models.shoppingcart.toKlarnaOrder();
            if (JSON.stringify(publics.klarnaOrder) === JSON.stringify(privates.oldKlarnaOrder)) {
                return false;
            }
            privates.oldKlarnaOrder = publics.klarnaOrder;

            window._klarnaCheckout &&
                window._klarnaCheckout(function (api) {
                    api.suspend({
                        autoResume: {
                            enabled: false,
                        },
                    });
                });

            publics.klarnaOrder.post(function (data) {
                if (data.success) {
                    if (privates.timeout) {
                        clearTimeout(privates.timeout);
                    }

                    var kcoContainer = $('#checkout-klarna .klarna');

                    if (data.readonly) {
                        location.href = '/klarna/confirmation/' + data.id + '?ro';
                    } else if (
                        partyking.config.retailer &&
                        partyking.config.retailer_minimum_order * 100 > data.create.totals.subtotal_excl_taxes
                    ) {
                        kcoContainer
                            .html(
                                '<div class="mt-10 bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative warning-delivery-message" role="alert">' +
                                    partyking.common.helpers.l
                                        .translate(
                                            'Minsta ordervärde som återförsäljare är %minimum_order% (exklusive moms, exklusive frakt). Du har %sum% kvar för att kunna lägga din beställning.'
                                        )
                                        .replace(
                                            '%sum%',
                                            partyking.common.helpers.display_price(
                                                (partyking.config.retailer_minimum_order * 100 -
                                                    data.create.totals.subtotal_excl_taxes) /
                                                    100
                                            )
                                        )
                                        .replace(
                                            '%minimum_order%',
                                            partyking.common.helpers.display_price(
                                                partyking.config.retailer_minimum_order
                                            )
                                        ) +
                                    '</div>'
                            )
                            .data('minimum_order', true);
                    } else if (
                        (data.changed ||
                            firstLoad ||
                            kcoContainer.data('minimum_order') ||
                            $.trim(kcoContainer.html()) == '') &&
                        publics.allowResume
                    ) {
                        kcoContainer.data('minimum_order', false);
                        if (kcoContainer.size() > 0) {
                            kcoContainer.html(data.snippet);
                            _.defer(function () {
                                privates.syncWithCustomer();
                            });
                        } else {
                            publics.waitingForOnload = true;
                            publics.changesWaiting = false;

                            $(function () {
                                kcoContainer.html(data.snippet);
                                _.defer(function () {
                                    privates.syncWithCustomer();
                                });

                                publics.waitingForOnload = false;

                                if (publics.changesWaiting) {
                                    publics.changesWaiting = false;
                                    publics.updateOrder();
                                }
                            });

                            return false;
                        }
                    }

                    if (publics.changesWaiting) {
                        publics.changesWaiting = false;
                        publics.updateOrder();
                        return false;
                    }
                } else {
                    if (!privates.timeout) {
                        privates.timeout = setTimeout(function () {
                            publics.updateOrder(firstLoad);
                        }, 1000);
                    }
                }

                window._klarnaCheckout &&
                    window._klarnaCheckout(function (api) {
                        api.resume();
                    });
            });
        };

        privates.setVoyadoContact = function (email) {
            fetch(`/contacts/klarna-form?email=${email}`).then((response) => {
                if (response.status !== 200) {
                    return;
                }
            });
        };

        privates.syncWithCustomer = function () {
            if (!window._klarnaCheckout || privates.syncRegistered) {
                return false;
            }

            privates.syncRegistered = true;

            window._klarnaCheckout(function (api) {
                api.on({
                    change: function (data) {
                        try {
                            if (data.email) {
                                if (window.profitMetrics !== undefined) {
                                    window.profitMetrics.setEmail(data.email);
                                }

                                if (window.raptor !== undefined) {
                                    window.raptor.push('setRuid', data.email);
                                }

                                privates.setVoyadoContact(data.email);
                            }
                        } catch (error) {
                            Bugsnag.notify('PROFIT-METRICS ERROR', error);
                        }
                    },
                    redirect_initiated: function () {
                        publics.allowResume = false;
                    },
                    shipping_option_change: function (data) {
                        var id = data.id;
                        var price = data.price;
                        if (id.indexOf(':') > 0) {
                            var id_split = id.split(':');
                            var id = id_split[0];
                            var price_without_expedited_packing = parseInt(id_split[1]);
                            var expedited_packing = parseInt(id_split[2]);
                            var used_gift_card_for_shipping = parseInt(id_split[3]);
                            var price_excl = data.price - data.tax_amount;
                            if (price_without_expedited_packing - used_gift_card_for_shipping == price_excl) {
                                // No expedited_packing
                                var price = price_without_expedited_packing;
                            } else if (
                                price_without_expedited_packing == 0 &&
                                price_without_expedited_packing + expedited_packing - used_gift_card_for_shipping ==
                                    price_excl
                            ) {
                                // Free shipping, used gift card for express_packing
                                var price = expedited_packing;
                            } else {
                                var price = price_without_expedited_packing + expedited_packing;
                            }
                        }
                        partyking.common.models.shoppingcart.delivery.setDeliveryMethodByIdAndPrice(id, price);
                        partyking.common.trigger('shippingOptionChanged', data);
                    },
                });
            });
        };
        return publics;
    }

    return KlarnaController;
});
